export default __webpack_public_path__ + "static/media/photo--lg--huda-6.ecfbedc7.jpg";